var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"time",style:(_vm.bckStyle)},[_vm._v(" "+_vm._s(_vm.hours)+":"+_vm._s(_vm.minutes)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }